import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// project import
import axios from 'utils/axios';

// types
import { MenuProps } from 'types/menu';

// initial state
const initialState: MenuProps = {
  openItem: ['dashboard'],
  openComponent: 'buttons',
  currentEventId: undefined,
  currentContactId: undefined,
  currentVenueId: undefined,
  drawerOpen: false,
  componentDrawerOpen: false,
  menu: {},
  error: null,
  dataLoading: false
};

// ==============================|| SLICE - MENU ||============================== //

export const fetchMenu = createAsyncThunk('', async () => {
  const response = await axios.get('/api/menu/dashboard');
  return response.data;
});

const menu = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    activeItem(state, action) {
      state.openItem = action.payload.openItem;
    },

    setCurrentEventId(state, action) {
      state.currentEventId = action.payload;
    },

    setCurrentVenueId(state, action) {
      state.currentVenueId = action.payload;
    },

    setCurrentContactId(state, action) {
      state.currentContactId = action.payload;
    },

    activeComponent(state, action) {
      state.openComponent = action.payload.openComponent;
    },

    openDrawer(state, action) {
      state.drawerOpen = action.payload;
    },

    openComponentDrawer(state, action) {
      state.componentDrawerOpen = action.payload.componentDrawerOpen;
    },

    hasError(state, action) {
      state.error = action.payload;
    },

    setDataLoading(state, action) {
      state.dataLoading = action.payload;
    }
  },

  extraReducers(builder) {
    builder.addCase(fetchMenu.fulfilled, (state, action) => {
      state.menu = action.payload.dashboard;
    });
  }
});

export default menu.reducer;

export const {
  activeItem,
  activeComponent,
  openDrawer,
  openComponentDrawer,
  setCurrentEventId,
  setCurrentContactId,
  setDataLoading,
  setCurrentVenueId
} = menu.actions;
